import { Num, Plural, T, Var } from 'gt-react';
import type { SchemaGroupReading } from './workbookSchemaGroup';

/** What a group reads: all of a schema's data sources (less some), or a number of them. */
export function WorkbookSchemaGroupSummary({
  reading,
}: {
  reading: SchemaGroupReading;
}) {
  const { schemaName, excluded, members } = reading;
  if (!reading.all)
    return schemaName ? (
      <T context="workbook schema group summary">
        <Num>{members.length}</Num>{' '}
        <Plural n={members.length} one="data source" other="data sources" /> in
        ‘<Var>{schemaName}</Var>’
      </T>
    ) : (
      <T context="workbook schema group summary">
        <Num>{members.length}</Num>{' '}
        <Plural n={members.length} one="data source" other="data sources" />
      </T>
    );
  if (!schemaName)
    return (
      <T context="workbook schema group summary">
        All data sources in a schema
      </T>
    );
  if (!excluded)
    return (
      <T context="workbook schema group summary">
        All data sources in ‘<Var>{schemaName}</Var>’
      </T>
    );
  return (
    <T context="workbook schema group summary">
      All data sources in ‘<Var>{schemaName}</Var>’ except <Num>{excluded}</Num>
    </T>
  );
}
